import { AuthService, User } from './../user/auth.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { RegistryFirebaseService } from './../registry/registry-firebase.service';

@Injectable()
export class UserResolve implements Resolve<any> {

  constructor(
    private _authService: AuthService,
    private router: Router
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<User> {
    return this._authService.user.take(1)
      .map(x => {

        if (x) {
          return x;
        } else {
          return Observable.create(null);
        }
      }).catch(err => {
console.log(err)
        this.router.navigate(['/']);
        return Observable.of(false);
      });


    // return this.service.getUser(id)
    // .catch(err => {
    //   this.router.navigate(['/users']);
    //   return Observable.of(false);
    // });


  }
}



// WEBPACK FOOTER //
// ./src/app/user/user.resolve.ts